<template>
  <div>
    <van-popup v-model="visible" position="bottom" :style="{ height: '60%' }">
      <div class="store-select">
        <div class="picker-header">
          <div class="cancel-btn" @click="close">{{ $t('button.cancel') }}</div>
          <div class="title">{{ $t('button.select') }} {{ apiType === 2 ? $t('shared.distributor') : $t('shared.store')}}</div>
          <!-- <div class="confirm-btn" @click="onConfirmMulti" v-if="multiple">Confirm</div> -->
          <div class="confirm-btn"></div>
        </div>
        <van-search v-model="searchValue" :placeholder="`${$t('button.search')} ${ apiType === 2 ? $t('shared.distributor') : $t('shared.store')}`" @search="onSearch" @clear="onSearch" />
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="$t('tips.noMore')"
          @load="onLoadStore"
          class="store-list-container"
        >
          <van-cell
            v-for="item in storeList"
            :key="item.id"
            :title="item.customerName"
            clickable
            @click="onConfirmStore(item)"
          >
            <template #title>
              <div class="store-main-content">
                <van-checkbox :value="isChecked(item)" shape="square" v-if="multiple" style="margin-right: 10px;"></van-checkbox>
                <van-radio-group v-model="radioVal" direction="horizontal" v-if="!multiple && ['incentive', 'storeGroup'].includes(pageType)">
                  <van-radio :name="item.id" shape="square"></van-radio>
                </van-radio-group>
                <div style="flex: 1;">
                  <div class="store-info">
                    <span v-if="apiType != 2 && item.customerTag" class="store-status txt-ellipsis" :class="item.customerTag | formatTagClass">
                      {{ item.customerTag | formatTag }}
                    </span>
                    <span v-if="apiType == 2" class="store-status txt-ellipsis" :class="{ 'tag3': item.businessType === 'Open System', 'tag2': item.businessType === 'Closed & Open System' }">{{ item.businessType }}</span>
                    <span v-if="apiType == 2" class="store-name txt-ellipsis">{{ item.sdName }}</span>
                    <span v-else class="store-name txt-ellipsis">{{ item.customerName }}</span>
                  </div>
                  <div class="address-info">
                    <img class="address-img" src="@/assets/images/ditu.png" alt="" />
                    <span class="address-name txt-ellipsis">{{ item.address }}</span>
                  </div>
                </div>
              </div>
            </template>
          </van-cell>
        </van-list>
        <div class="bottom-action" v-if="pageType === 'incentive'">
          <van-button class="view-btn" type="info" block @click="handleOper('code')">{{ $t('button.btnCode') }}</van-button>
        </div>
        <div class="bottom-action" v-if="pageType === 'storeGroup'">
          <van-button class="clear-btn" type="info" block @click="handleOper('clear')">{{ $t('button.clearSelected') }}<br />({{ $t('button.selected') }}{{ checkedList.length }})</van-button>
          <van-button class="invite-btn" type="info" block @click="handleOper('add')">{{ $t('button.addToStoreGroup') }}</van-button>
        </div>
      </div>
    </van-popup>
    <van-dialog v-model="inviteShow" title="" :showConfirmButton="false">
      <div class="invite-dialog-btn">
        <div class="invite-info">{{ $t('tips.messageThree') }}</div>
        <div class="qrcode-section" ref="qrCodeRef"></div>
        <!-- 长按保存到相册 -->
        <div class="dialog-btn">
          <van-button color="#307bff" class="xu-btn" type="info" @click="inviteShow=false">{{ $t('button.close') }}</van-button>
        </div>
        <div class="mark-tips">{{ $t('tips.messageFour') }}</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { arsCustomerAppListPageApi, arsActivityQrCodeApi } from '@/api/home'
import { sdAppListPageApi } from '@/api/salesDistribution'
import { arsLabelRelevancyAddApi } from '@/api/storePage'
import QRCode from 'qrcodejs2'
import { Toast } from 'vant'
import i18n from '@/i18n'
export default {
  name: 'XuStoreSelect',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    pageType: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    currentGroup: {
      type: Object,
      default: () => {}
    },
    apiType: {
      type: [String, Number],
      default: ''
    }
  },
  filters: {
    formatTag (value) {
      return value === 0 ? i18n.t('shared.filter.toBeVerified') : value === 1 ? i18n.t('shared.filter.sVIPCore') : value === 2 ? i18n.t('shared.filter.vIPCore') : value === 3 ? i18n.t('shared.filter.potential') : ''
    },
    formatTagClass (value) {
      return `tag${value}`
    }
  },
  data () {
    return {
      visible: this.value,
      searchValue: '',
      loading: false,
      finished: false,
      page: 1,
      pageSize: 20,
      storeList: [],
      timer: null,
      radioVal: '',
      inviteShow: false,
      qrcodeUrl: null,
      checkedList: []
    }
  },
  watch: {
    value (val) {
      this.visible = val
      if (val) {
        // Reset when opening
        this.page = 1
        this.finished = false
        this.storeList = []
        this.checkedList = []
        this.loading = true // Set loading true initially to prevent immediate finish
        this.onLoadStore()
      }
    },
    visible (val) {
      if (!val) {
        this.radioVal = ''
        this.qrcodeUrl = null
      } else {
        if (this.multiple) {
          this.checkedList = this.currentGroup.relevancyList
        }
      }
      this.$emit('input', val)
    }
  },
  methods: {
    close () {
      this.visible = false
    },
    async onLoadStore () {
      try {
        const resquestApi = this.apiType === 2 ? sdAppListPageApi : arsCustomerAppListPageApi
        const res = await resquestApi({
          page: this.page,
          limit: this.pageSize,
          search: this.searchValue,
          sortField: 'customerTag',
          order: '0'
        })
        if (this.page === 1) {
          this.storeList = res.data.list
        } else {
          this.storeList = [...this.storeList, ...res.data.list]
        }

        this.loading = false

        if (this.storeList.length >= Number(res.data.totalRow)) {
          this.finished = true
        } else {
          this.page++
        }
      } catch (error) {
        this.loading = false
        this.finished = true
      }
    },
    onSearch () {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.page = 1
        this.finished = false
        this.storeList = []
        this.loading = true
        this.onLoadStore()
      }, 500)
    },
    onConfirmStore (item) {
      if (this.multiple) {
        this.toggleSelection(item)
        return
      }
      if (this.pageType === 'incentive') {
        return
      }
      this.$emit('confirm', item)
      this.close()
    },
    isChecked (item) {
      return this.checkedList.some(i => i.id === item.id)
    },
    toggleSelection (item) {
      const index = this.checkedList.findIndex(i => i.id === item.id)
      if (index > -1) {
        this.checkedList.splice(index, 1)
      } else {
        this.checkedList.push(item)
      }
    },
    // onConfirmMulti () {
    //   this.$emit('confirm', this.checkedList)
    //   this.close()
    // },
    handleOper (type) {
      if (type === 'code') {
        if (!this.radioVal) {
          Toast(this.$t('form.ruleTipsOne'))
          return
        }
        Toast.loading({
          message: this.$t('shared.loading'),
          forbidClick: true,
          duration: 0
        })
        arsActivityQrCodeApi(this.radioVal).then(res => {
          Toast.clear()
          this.inviteShow = true
          this.$nextTick(() => {
            if (this.qrcodeUrl) {
              this.qrcodeUrl.clear()
              this.qrcodeUrl.makeCode(res.data)
            } else {
              this.qrcodeUrl = new QRCode(this.$refs.qrCodeRef, {
                text: res.data,
                width: this.$refs.qrCodeRef.offsetWidth,
                height: this.$refs.qrCodeRef.offsetHeight,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.M
              })
            }
          })
        })
      } else if (['add', 'clear'].includes(type)) {
        const data = {
          labelId: this.currentGroup.id,
          relevancyIdList: type === 'add' ? this.checkedList.map(subItem => subItem.id) : []
        }
        Toast.loading({
          message: this.$t('shared.loading'),
          forbidClick: true,
          duration: 0
        })
        arsLabelRelevancyAddApi(data).then(res => {
          Toast.clear()
          this.checkedList = type === 'add' ? this.checkedList : []
          this.$emit('confirm', this.checkedList)
          if (type === 'add') {
            this.visible = false
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.store-select {
  display: flex;
  flex-direction: column;
  height: 100%;
  .store-list-container {
    flex: 1;
    /deep/.van-cell {
      padding: 10px;
    }
  }
  .bottom-action {
    display: flex;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
    .view-btn {
      background-color: #307bff;
    }
    .clear-btn {
      background-color: #fff;
      color: #c4200b;
    }
    .invite-btn {
      background-color: #307bff;
    }
    /deep/.van-button {
      border: none;
      border-radius: 0;
      .van-button__text {
        font-weight: bold;
      }
    }
  }
}
.picker-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 44px;
  padding: 0 16px;
  border-bottom: 1px solid #ebedf0;

  .cancel-btn {
    font-size: 14px;
    color: #969799;
    cursor: pointer;
  }

  .title {
    font-size: 16px;
    font-weight: 500;
    color: #323233;
  }

  .confirm-btn {
    font-size: 14px;
    color: #576b95;
    cursor: pointer;
    min-width: 40px; /* Placeholder width to center title */
  }
}

.store-list-container {
  height: calc(100% - 100px); /* Adjust based on header + search height */
  overflow-y: auto;
}

.store-main-content {
  display: flex;
  align-items: center;
}

.store-info {
  display: flex;
  align-items: center;
  margin-bottom: 4px;

  .store-status {
    max-width: 86px;
    padding: 0px 5px;
    text-align: center;
    font-size: 10px;
    border: 1px solid #ee541b;
    color: #ee541b;
    background-color: #eccfc4;
    margin-right: 2px;

    &.unverified-store {
      color: #0db00b;
      border: 1px solid #0db00b;
      background-color: rgba(13, 176, 11, 0.19);
    }
    &.regular-store {
      color: #7f7f7f;
      background-color: rgba(127, 127, 127, 0.19);
      border-color: #7f7f7f;
    }
  }
  .tag0 {
    border: 1px solid #0db00b;
    color: #0db00b;
    background-color: #abdaaa;
  }
  .tag2 {
    border: 1px solid #dc851f;
    color: #dc851f;
    background-color: #f0e2d1;
  }
  .tag3 {
    border: 1px solid #0db00b;
    color: #0db00b;
    background-color: #abdaaa;
  }

  .store-name {
    max-width: 236px;
    font-size: 14px;
    color: #333;
    font-weight: 500;
  }
}

.address-info {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #999;

  .address-img {
    width: 12px;
    height: 12px;
    margin-right: 4px;
  }

  .address-name {
    max-width: 310px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.invite-dialog-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  .invite-info {
    text-align: center;
  }
  .qrcode-section {
    width: 230px;
    height: 230px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .mark-tips {
    font-size: 12px;
    margin-top: 10px;
  }
  .xu-btn {
    width: 200px;
  }
}
</style>
